<div class="container">
  <div class="content">
    <div class="qrCode">
      <qrcode
        *ngIf="dataString != null"
        [qrdata]="dataString"
        [width]="256"
        [errorCorrectionLevel]="'M'"
      ></qrcode>
    </div>
    <div class="qrCodePlaceholder" *ngIf="dataString == null">
      <div class="loader"></div>
    </div>
    <div class="infoText" i18n>Scan the QR code to login automatically.</div>
    <div class="buttonDiv">
      <button mat-raised-button i18n (click)="closeDialog()">
        <mat-icon>close</mat-icon>Close
      </button>
    </div>
  </div>
</div>
